


// ProjectFullView.jsx
import React, { useEffect, useState } from "react";
import "../CSS/projectFullView.css";
import { BASE_API_URL } from "../constants";

const ProjectFullView = () => {
  const [project, setProject] = useState(null);

  const projectId = window.location.pathname.split("/").pop();

  useEffect(() => {
    fetch(`${BASE_API_URL}/api/projects/${projectId}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch project");
        return res.json();
      })
      .then((data) => {
        // Clean up text fields
        const cleanText = (text) =>
          text ? text.replace(/^"|"$/g, "") : "";

        setProject({
          ...data,
          briefStory: cleanText(data.briefStory),
          aboutProject: cleanText(data.aboutProject),
          whySupport: cleanText(data.whySupport),
          timeline: cleanText(data.timeline),
          utilization: cleanText(data.utilization),
          recoveryPlan: cleanText(data.recoveryPlan),
          experience: cleanText(data.experience),
          marketingPlan: cleanText(data.marketingPlan),
          contributionDetails: cleanText(data.contributionDetails),
          team: Array.isArray(data.team) ? data.team : [],
          supportNeeded: Array.isArray(data.supportNeeded) ? data.supportNeeded : [],
          posters: Array.isArray(data.posters) ? data.posters : [],
          gallery: Array.isArray(data.gallery) ? data.gallery : [],
          investmentFeatures: Array.isArray(data.investmentFeatures)
            ? data.investmentFeatures
            : [],
          statusFeatures: Array.isArray(data.statusFeatures) ? data.statusFeatures : [],
        });
      })
      .catch((err) => console.error(err));
  }, [projectId]);

  if (!project) return <p className="uv-loading">Loading...</p>;

  return (
    <div className="uv-app-container">
      <div className="uv-sidebar-space"></div>
      <main className="uv-main-content">
        {/* Hero Section */}
        <section className="uv-project-hero">
          <div className="uv-project-hero-bg"></div>
          <div className="uv-project-hero-content">
            <div className="uv-project-poster">
              <img
                src={project.posters?.[0] || "https://via.placeholder.com/400x600"}
                alt="Project Poster"
              />
            </div>
            <div className="uv-project-info">
              <span className="uv-project-genre">{project.genres || project.genreCatery}</span>
              <h1 className="uv-project-title">{project.title}</h1>
              <div className="uv-project-meta">
                <div className="uv-meta-item">
                  <i className="fas fa-language"></i>
                  <span>{project.language}</span>
                </div>
                <div className="uv-meta-item">
                  <i className="fas fa-film"></i>
                  <span>{project.type}</span>
                </div>
                <div className="uv-meta-item">
                  <i className="fas fa-user-friends"></i>
                  <span>{project.targetAudience}</span>
                </div>
              </div>
              <p className="uv-project-description">{project.briefStory}</p>
              <div className="uv-cta-buttons">
                <a href="#invest" className="uv-cta-button uv-primary-btn">
                  Contribute in Project
                </a>
                {project.videoLink && (
                  <a href={project.videoLink} className="uv-cta-button uv-secondary-btn">
                    Watch Trailer
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Details Section */}
        <section className="uv-project-details">
          <div className="uv-details-container">
            <div className="uv-details-main">
              <h2 className="uv-section-title">About Project</h2>
              <p>{project.aboutProject}</p>

              <h2 className="uv-section-title">Why Support</h2>
              <p>{project.whySupport}</p>

              <h2 className="uv-section-title">Timeline</h2>
              <p>{project.timeline}</p>

              <h2 className="uv-section-title">Funding & Utilization</h2>
              <p>Goal: {project.fundingal}</p>
              <p>Minimum Contribution: {project.minContribution}</p>
              <p>Utilization: {project.utilization}</p>
              <p>Recovery Plan: {project.recoveryPlan}</p>
              <p>Profit Plan: {project.profitPlan}%</p>

              <h2 className="uv-section-title">Team / Cast & Crew</h2>
              <div className="uv-team-grid">
                {project.team.map((member, idx) => (
                  <div key={idx} className="uv-team-member">
                    <img
                      src={member.photo || "https://via.placeholder.com/150"}
                      alt={member.role}
                      className="uv-member-photo"
                    />
                    <h3 className="uv-member-name">{member.name}</h3>
                    <p className="uv-member-role">{member.role}</p>
                  </div>
                ))}
              </div>

              <h2 className="uv-section-title">Gallery / Posters</h2>
              <div className="uv-gallery-grid">
                {project.gallery.map((img, idx) => (
                  <div key={idx} className="uv-gallery-item">
                    <img src={img} alt="Gallery" />
                  </div>
                ))}
              </div>

              <h2 className="uv-section-title">Marketing Plan</h2>
              <p>{project.marketingPlan}</p>

              <h2 className="uv-section-title">Experience / Previous Works</h2>
              <p>{project.experience}</p>
            </div>

            {/* Sidebar */}
            <div className="uv-details-sidebar">
              <div id="invest" className="uv-investment-card">
                <h2 className="uv-section-title">Support Needed</h2>
                {project.supportNeeded.map((s, idx) => (
                  <div key={idx}>
                    <p>{s}</p>
                  </div>
                ))}

                <h2 className="uv-section-title">Investment Features</h2>
                {project.investmentFeatures.map((f, idx) => (
                  <div key={idx}>
                    <p>{f}</p>
                  </div>
                ))}

                <a
                  href="/contribute"
                  className="uv-cta-button uv-primary-btn"
                  style={{ display: "block", textAlign: "center", marginTop: "1.5rem" }}
                >
                  Contribute Now
                </a>
              </div>

              <div className="uv-investment-card">
                <h2 className="uv-section-title">Project Status</h2>
                <p>Status: {project.status}</p>
                {project.statusFeatures.map((f, idx) => (
                  <div key={idx}>
                    <strong>{f.title}:</strong> {f.detail}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ProjectFullView;
